<template>
  <div class="user-guideline">
    <AppSectionHero
      :title="$t('pages.user.guideline.title')"
      :subtitle="$t('pages.user.guideline.subtitle')"
      :show-refresh="false"
      :meta-label="$t('pages.user.guideline.currentVersion')"
      :meta-value="guideline.updatedLabel"
    />

    <CCard class="border-0 shadow-sm shell">
      <CCardBody class="p-4">
        <div class="highlight-grid">
          <div class="highlight-card" v-for="item in guideline.highlights" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.copy }}</p>
          </div>
        </div>

        <div class="content-grid">
          <div class="panel-card">
            <h3>{{ $t('pages.user.guideline.sections.workflow') }}</h3>
            <div class="step-list">
              <div class="step-row" v-for="(item, index) in guideline.workflow" :key="item">
                <span class="step-number">{{ index + 1 }}</span>
                <div class="step-copy">{{ item }}</div>
              </div>
            </div>
          </div>

          <div class="panel-card">
            <h3>{{ $t('pages.user.guideline.sections.resources') }}</h3>
            <div class="resource-list">
              <div class="resource-card" v-for="item in guideline.resources" :key="item.title">
                <div class="resource-title">{{ item.title }}</div>
                <div class="resource-copy">{{ item.copy }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-card">
          <h3>{{ $t('pages.user.guideline.sections.faq') }}</h3>
          <div class="faq-list">
            <div class="faq-item" v-for="item in guideline.faq" :key="item.question">
              <div class="faq-question">{{ item.question }}</div>
              <div class="faq-answer">{{ item.answer }}</div>
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Service from '@/service/api'
import AppSectionHero from '@/projects/components/layout/AppSectionHero'

export default {
  name: 'UserGuideline',
  components: { AppSectionHero },
  data() {
    return {
      guideline: {
        updatedLabel: '',
        highlights: [],
        workflow: [],
        faq: [],
        resources: []
      }
    }
  },
  computed: {
    localeCode() {
      return String(this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'th').toLowerCase().split(/-|_/)[0] || 'th'
    }
  },
  mounted() {
    this.loadGuideline()
  },
  watch: {
    '$i18n.locale'() {
      this.loadGuideline()
    }
  },
  methods: {
    async loadGuideline() {
      const response = await Service.userWorkspace('guideline', { lang: this.localeCode })
      this.guideline = response && response.data && response.data.data ? response.data.data : this.guideline
    }
  }
}
</script>

<style scoped lang="scss">
@import "../shared/workspace-consistency.scss";

@include workspace-page-frame("user-guideline");
@include workspace-info-layout;
</style>
